import { numberWithCommas } from '../common/util';
import { UIDialog } from '../common/ui/uiDialog';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
// import { Site } from 'src/site/site';
import { Game, GameMode } from './game';
import { GameStyle } from './gameStyle';
import { Server } from '../../server/server';
import Levels from './assets/levels.json';
import { UIImage } from '../common/ui/uiImage';
import { Database } from '../../server/database';
import { getAssetImage } from '../../app/util/util';

export class GameOverDialog extends UIDialog {
  protected titleText: UIText;
  protected bestScoreLabel: UIText;
  protected bestScoreText: UIText;
  protected winBonusLabel: UIText;
  protected winBonusText: UIText;
  protected timeBonusLabel: UIText;
  protected timeBonusText: UIText;
  protected totalScoreLabel: UIText;
  protected totalScoreText: UIText;
  protected nextButton: UIPanelButton;
  protected mapButton: UIPanelButton;
  adventureScoreLabel: UIText;
  adventureScoreText: UIText;

  nextLevel: number;
  scoreLabel: UIText;
  scoreText: UIText;
  rewardsPanel: UIPanel;
  rewardsLoadingText: UIText;
  playAgainButton: UIPanelButton;
  quitButton: UIPanelButton;

  public build() {
    this.popup = new UIPanel({
      size: {x: 300, y: 355},
      anchor: {x: 0.5, y: 0.45},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      radius: GameStyle.dialog.panel.radius,
      color: GameStyle.dialog.panel.color,
      gradient: GameStyle.dialog.panel.gradient,
      borderColor: GameStyle.dialog.panel.borderColor,
      borderWidth: GameStyle.dialog.panel.borderWidth,
      shadow: GameStyle.dialog.panel.shadow,
      parent: this
    });

    let titleText = new UIText({
      text: 'GAME OVER!',
      position: {x: 0, y: 10},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.dialog.title.color,
      fontFamily: GameStyle.dialog.title.fontFamily,
      fontSize: GameStyle.dialog.title.fontSize,
      fontWeight: GameStyle.dialog.title.fontWeight,
      shadow: GameStyle.dialog.title.shadow,
      parent: this.popup
    });

    this.scoreLabel = new UIText({
      text: 'SCORE',
      position: {x: 0, y: 45},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize+2,
      fontWeight: '700',
      parent: this.popup
    });

    this.scoreText = new UIText({
      text: '1,234',
      position: {x: 0, y: 65},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.score.color,
      fontFamily: GameStyle.results.score.fontFamily,
      fontSize: GameStyle.results.score.fontSize,
      fontWeight: GameStyle.results.score.fontWeight,
      parent: this.popup
    });

    this.bestScoreLabel = new UIText({
      text: 'BEST SCORE',
      position: {x: 0, y: 105},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.bestScoreText = new UIText({
      text: '12,345',
      position: {x: 0, y: 122},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.score.color,
      fontFamily: GameStyle.results.score.fontFamily,
      fontSize: GameStyle.results.score.fontSize,
      fontWeight: GameStyle.results.score.fontWeight,
      parent: this.popup
    });

    let rewardsTitle = new UIText({
      text: 'REWARDS',
      position: {x: 0, y: 165},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.rewardsPanel = new UIPanel({
      size: {x: 270, y: 100},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      position: {x: 0, y: 185},
      color: '#00000040',
      radius: 10,
      parent: this.popup
    })

    this.rewardsLoadingText = new UIText({
      text: 'Loading...',
      position: {x: 0, y: 235},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0.5},
      color: GameStyle.results.label.color,
      fontFamily: GameStyle.results.label.fontFamily,
      fontSize: GameStyle.results.label.fontSize,
      fontWeight: GameStyle.results.label.fontWeight,
      parent: this.popup
    });

    this.playAgainButton = new UIPanelButton({
      text : 'Play Again',
      anchor : {x : 1, y : 1},
      pivot : {x : 1, y : 1},
      position : {x : -15, y : -15},
      size : {x : 120, y : 40},
      callback : () => {
        this.onPlayAgain();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      textOffset: GameStyle.dialog.button.textOffset,
      borderColor: GameStyle.dialog.button.borderColor,
      borderWidth: GameStyle.dialog.button.borderWidth,
      parent : this.popup
    });

    this.quitButton = new UIPanelButton({
      text : 'Quit Game',
      anchor : {x : 0, y : 1},
      pivot : {x : 0, y : 1},
      position : {x : 15, y : -15},
      size : {x : 120, y : 40},
      callback : () => {
        this.hide();
        Game.instance.quit();
      },
      panelColors: GameStyle.dialog.button.panelColors,
      textColors: GameStyle.dialog.button.textColors,
      radius: GameStyle.dialog.button.radius,
      fontFamily: GameStyle.dialog.button.fontFamily,
      fontSize: GameStyle.dialog.button.fontSize,
      textOffset: GameStyle.dialog.button.textOffset,
      borderColor: GameStyle.dialog.button.borderColor,
      borderWidth: GameStyle.dialog.button.borderWidth,
      parent : this.popup
    });

    // this.mapButton = new UIPanelButton({
    //   text : 'Map',
    //   anchor : {x : 0, y : 1},
    //   pivot : {x : 0, y : 1},
    //   position : {x : 20, y : -20},
    //   size : {x : 120, y : 40},
    //   callback : () => {
    //     this.onMap();
    //   },
    //   panelColors: GameStyle.dialog.button.panelColors,
    //   textColors: GameStyle.dialog.button.textColors,
    //   radius: GameStyle.dialog.button.radius,
    //   fontFamily: GameStyle.dialog.button.fontFamily,
    //   fontSize: GameStyle.dialog.button.fontSize,
    //   textOffset: GameStyle.dialog.button.textOffset,
    //   borderColor: GameStyle.dialog.button.borderColor,
    //   borderWidth: GameStyle.dialog.button.borderWidth,
    //   parent : this.popup
    // });
  }

  // protected buildAdventureModePanel() {
  //   let scoreDetailPanel = new UIPanel({
  //     fitParent: {left: 20, right: 20, top: -1, bottom: -1},
  //     position : {x : 0, y : 50},
  //     size : {x : 0, y : 145},
  //     color : GameStyle.dialog.field.panel.color,
  //     radius : GameStyle.dialog.field.panel.radius,
  //     parent : this.popup
  //   });

  //   this.bestScoreLabel = new UIText({
  //     text : 'Base Score',
  //     position : {x : 10, y : 10},
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.bestScoreText = new UIText({
  //     text : '12,345',
  //     position : {x : -10, y : 10},
  //     anchor : {x : 1, y : 0},
  //     pivot : {x : 1, y : 0},
  //     horizontalAlign : 'right',
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.winBonusLabel = new UIText({
  //     text : 'Win Bonus',
  //     position : {x : 10, y : 35},
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.winBonusText = new UIText({
  //     text : '+1,000',
  //     position : {x : -10, y : 35},
  //     anchor : {x : 1, y : 0},
  //     pivot : {x : 1, y : 0},
  //     horizontalAlign : 'right',
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.timeBonusLabel = new UIText({
  //     text : 'Time Bonus',
  //     position : {x : 10, y : 60},
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.timeBonusText = new UIText({
  //     text : '+658',
  //     position : {x : -10, y : 60},
  //     anchor : {x : 1, y : 0},
  //     pivot : {x : 1, y : 0},
  //     horizontalAlign : 'right',
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.totalScoreLabel = new UIText({
  //     text : 'Game Score',
  //     position : {x : 10, y : 85},
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.totalScoreText = new UIText({
  //     text : '17,900',
  //     position : {x : -10, y : 85},
  //     anchor : {x : 1, y : 0},
  //     pivot : {x : 1, y : 0},
  //     horizontalAlign : 'right',
  //     color : GameStyle.dialog.message.color,
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.adventureScoreLabel = new UIText({
  //     text : 'Game Score',
  //     position : {x : 10, y : 110},
  //     color : '#ffff00',
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });

  //   this.adventureScoreText = new UIText({
  //     text : '17,900',
  //     position : {x : -10, y : 110},
  //     anchor : {x : 1, y : 0},
  //     pivot : {x : 1, y : 0},
  //     horizontalAlign : 'right',
  //     color : '#ffff00',
  //     fontFamily : GameStyle.dialog.message.fontFamily,
  //     fontSize : GameStyle.dialog.message.fontSize,
  //     parent : scoreDetailPanel
  //   });
  // }

  protected buildRewards(coins:number, asset:string) {
    if(coins == 0 && asset == '') {
      this.rewardsLoadingText.text = 'No rewards earned this game.';
      return;
    }

    this.rewardsLoadingText.visible = false;

    let rewardCount = 0;
    if(coins > 0) rewardCount++;
    if(asset != '') rewardCount++;

    if(coins > 0) {
      let coinPanel = new UIPanel({
        size: {x: 60, y: 60},
        anchor: {x: rewardCount == 1 ? 0.5 : 0.25, y: 0},
        pivot: {x: 0.5, y: 0},
        position: {x: 0, y: 12},
        radius: GameStyle.dialog.button.radius,
        color: '#00000040',
        borderColor: 'black',
        borderWidth: 2,
        parent: this.rewardsPanel
      });
  
      let coinImage = new UIImage ({
        url: '/assets/coin.png',
        size: {x: 50, y: 50},
        stretch: true,
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 0.5, y: 0.5},
        parent: coinPanel
      })
  
      let coinsEarnedText = new UIText({
        text: coins.toString() + ' Coins',
        position: {x: 0, y: 20},
        anchor: {x: 0.5, y: 1},
        pivot: {x: 0.5, y: 1},
        horizontalAlign: 'center',
        color: GameStyle.results.score.color,
        fontFamily: GameStyle.fonts.small.family,
        fontSize: GameStyle.fonts.small.size,
        fontWeight: '700',
        parent: coinPanel
      });
    }

    if(asset != '') {
      let assetInfo = Database.getAsset(asset);
      let assetName = assetInfo.name;

      if(assetInfo.type == 'pack')
        assetName = 'Pack';
      else if(assetInfo.type == 'consumable')
        assetName = 'Powerup';
      else if(assetInfo.category == 'landmark')
        assetName = 'Landmark';
      else if(assetInfo.category == 'banner')
        assetName = 'Banner';
      else if(assetInfo.category == 'portrait')
        assetName = 'Portrait';
      else
        assetName = '';
      
      let assetPanel = new UIPanel({
        size: {x: 60, y: 60},
        anchor: {x: rewardCount == 1 ? 0.5 : 0.75, y: 0},
        pivot: {x: 0.5, y: 0},
        position: {x: 0, y: 12},
        radius: GameStyle.dialog.button.radius,
        color: '#00000040',
        borderColor: 'black',
        borderWidth: 2,
        parent: this.rewardsPanel
      });

      let assetImage = new UIImage ({
        url: getAssetImage(assetInfo),
        size: {x: 50, y: 50},
        stretch: true,
        anchor: {x: 0.5, y: 0.5},
        pivot: {x: 0.5, y: 0.5},
        parent: assetPanel
      });

      if(assetInfo.category == 'banner') {
        assetImage.size = {x: 58, y: 0};
        assetImage.fitAspect = {x: 0, y: 160/600};
      }
  
      let assetNameText = new UIText({
        text: assetName,
        position: {x: 0, y: 20},
        anchor: {x: 0.5, y: 1},
        pivot: {x: 0.5, y: 1},
        horizontalAlign: 'center',
        color: GameStyle.results.score.color,
        fontFamily: GameStyle.fonts.small.family,
        fontSize: GameStyle.fonts.small.size,
        fontWeight: '700',
        parent: assetPanel
      });
    }
  }

  public onWake() {
    this.rewardsPanel.removeAllChildren();
    this.scoreText.text = numberWithCommas(Game.instance.matchThree.score);
    this.bestScoreLabel.text = 'BEST SCORE';
    this.bestScoreText.text = '-';
    this.rewardsLoadingText.visible = true;
    this.rewardsLoadingText.text = 'Loading...';
    this.recordScore();
  }

  protected async recordScore() {
    this.playAgainButton.disabled = true;

    Game.instance.recordScore(Game.instance.matchThree.score, (success:boolean, highScore:number, coins:number, asset:string)=>{
      this.playAgainButton.disabled = false;
      if(success) {
        this.buildRewards(coins, asset);
        this.bestScoreLabel.text = (Game.instance.matchThree.score == highScore) ? 'HIGH SCORE!' : 'BEST SCORE';
        this.bestScoreText.text = numberWithCommas(highScore);
      }
      else {
        this.bestScoreText.text = 'ERR';
        this.rewardsLoadingText.text = 'Failed to submit score!';
      }
    });
  }

  // protected oldOnWake() {
  //   let matchThree = Game.instance.matchThree;

  //   let wonGame = matchThree.isGameWon();

  //   this.titleText.text = 'GAME OVER';
  //   this.bestScoreLabel.text = 'Score';
  //   this.bestScoreText.text = numberWithCommas(matchThree.score);
  //   this.winBonusLabel.text = '';
  //   this.winBonusText.text = '';
  //   this.timeBonusLabel.text = '';
  //   this.timeBonusText.text = '';
  //   this.totalScoreLabel.text = '';
  //   this.totalScoreText.text = '';
  //   this.adventureScoreLabel.text = '';
  //   this.adventureScoreText.text = '';

  //   if (matchThree.haveGoals) {
  //     this.titleText.text = wonGame ? 'GAME WON!' : 'GAME LOST';
  //     this.bestScoreLabel.text = 'Base Score';
  //     this.bestScoreText.text = numberWithCommas(matchThree.score);
  //     this.winBonusLabel.text = 'Win Bonus';
  //     this.winBonusText.text = `+${numberWithCommas(matchThree.wonGameBonus)}`;
  //     this.timeBonusLabel.text = 'Time Bonus';
  //     this.timeBonusLabel.text = matchThree.isTimedGame() ? 'Time Bonus' : 'Moves Bonus';
  //     this.timeBonusText.text = `+${numberWithCommas(matchThree.timeOrMovesBonus)}`;
  //     this.totalScoreLabel.text = 'Game Score';
  //     this.totalScoreText.text = numberWithCommas(matchThree.score + matchThree.wonGameBonus + matchThree.timeOrMovesBonus);
  //     this.adventureScoreLabel.text = 'Adventure Score';
  //     this.adventureScoreText.text = numberWithCommas(matchThree.totalScore);
  //   }
  //   else if(Game.instance.gameMode == GameMode.Arcade) {
  //     this.winBonusLabel.text = 'Best Score';
  //     this.winBonusText.text = '-';
  //     this.timeBonusLabel.text = 'Coins Earned';
  //     this.timeBonusText.text = '-';
  //   }

  //   if (Game.instance.gameMode == GameMode.Adventure) {
  //     this.nextButton.text = wonGame ? 'Next Level' : 'Replay';
  //     this.nextButton.anchor.x = 1;
  //     this.nextButton.pivot.x = 1;
  //     this.nextButton.position.x = -20;
  //     this.mapButton.visible = true;
  //   }
  //   else {
  //     this.nextButton.text = 'Continue';
  //     this.nextButton.anchor.x = 0.5;
  //     this.nextButton.pivot.x = 0.5;
  //     this.nextButton.position.x = 0;
  //     this.mapButton.visible = false;
  //   }

  //   // Get Coins Earned and High Score via web service when playing the Arcade mode.
  //   if (Game.instance.gameMode == GameMode.Arcade) 
  //     this.recordScore();
  //   else if(Game.instance.gameMode == GameMode.Adventure && Game.instance.matchThree.isGameWon()) {
  //     let highLevel = Game.instance.getAdventureCookie().level;

  //     if (highLevel == Game.instance.levelSelected) {
  //       this.nextLevel = highLevel + 1;
  //       Game.instance.levelSelected++;
  //       Game.instance.setAdventureCookie(this.nextLevel, Game.instance.matchThree.totalScore);
  //     }
  //     else {
  //       this.nextLevel = Game.instance.levelSelected + 1;
  //       Game.instance.levelSelected++;
  //     }
  //   }
  // }

  protected onNext() {
    // console.log('this.nextButton.text',this.nextButton.text)
    this.hide();

    // Next Level button is pressed
    if(Game.instance.gameMode == GameMode.Adventure && Game.instance.matchThree.isGameWon()) {
      let level = this.nextLevel;
      while(level > Levels.length) 
        level -= Levels.length;
      Game.instance.startGame(Levels[level - 1]);
      return;
    }

    // Replay button is pressed
    if(Game.instance.gameMode == GameMode.Adventure && !Game.instance.matchThree.isGameWon()) {
      Game.instance.startGame(Levels[Game.instance.levelSelected]);
      return;
    }

    // Continue button is pressed
    Game.instance.askQuestion('Would you like to play again?', (response:string)=>{
      if(response == 'Yes') {
        if(Game.instance.gameMode == GameMode.Arcade)
          Game.instance.arcadeMode();
        else
          Game.instance.mapScreen.show();
      }
      else
        Game.instance.quit();
    });

    // if(Site.room.isActive())
    //   Game.game.showRoom();
    // else
    //   Game.game.showNextBoardSettings();
  }

  protected onPlayAgain() {
    if(Game.instance.isTournament()) {
      let costToPlay = Database.getTournamentCost('matcha-blitz');
      if(Server.user.getCoinCount() < costToPlay) {
        Game.instance.showAlert('You do not have enough coins\nto play another contest game.');  
        return;     
      }
    }

    this.hide();
    Game.instance.arcadeMode();
  }

  protected onMap() {
    this.hide();
    // let level = Game.instance.getAdventureCookie().level;
    // Game.instance.startGame(Levels[level]);
    Game.instance.mapScreen.show();
  }

  // protected async recordScore() {
  //   let matchThree = Game.instance.matchThree;

  //   this.nextButton.disabled = true;

  //   Game.instance.recordScore(matchThree.score, (success:boolean, highScore:number, coins:number, asset:string)=>{
  //     this.nextButton.disabled = false;

  //     if(success) {
  //       this.winBonusLabel.text = (matchThree.score == highScore) ? 'High Score!' : 'Best Score';
  //       this.winBonusText.text = numberWithCommas(highScore);
  //       this.timeBonusText.text = coins.toString();
  //     }
  //     else {
  //       this.winBonusText.text = 'ERR';
  //       this.timeBonusText.text = 'ERR';
  //     }
  //   });
  // }
}